import { isBrowser, isProduct, isTestnet, pipelineEnv, isLocal } from './env';
import { LOCALES } from './config/i18n-config';

export function getDomain() {
  if (!isBrowser) return 'bybit.com';
  return window.location.host.split('.').slice(1).join('.')?.split(':').shift();
}

export function getProtocol() {
  if (!isBrowser) return isProduct || isTestnet ? 'https:' : 'http:';
  const { protocol } = window.location;
  return protocol;
}

export function getTestDomain() {
  return `${pipelineEnv}.bybit.com`;
}

export const getApiHost = () => {
  if (isProduct) {
    return `https://api2.${getDomain()}`;
  }

  if (isTestnet) {
    return `https://api2-testnet.${getDomain()}`;
  }

  return `${getProtocol()}//api2.${getTestDomain()}`;
};

export const APIBaseURL = getApiHost();

export const addPathPrefix = <T extends string>(path: T): T => {
  if (!path.startsWith('/')) {
    return ('/' + path) as T;
  }
  return path;
};

export const getSearchParams = () => {
  if (!isBrowser) return {};

  const searchParams = new URLSearchParams(window.location.search);
  const browserSearch = {};
  searchParams.forEach((value, key) => {
    browserSearch[key] = value;
  });

  return browserSearch;
};

export const replaceBybitToLocationHost = (url: string = '') => {
  if (isLocal) return url;
  return url.replace('www.bybit.com', window.location.host);
};

// 判断是否为荷兰站
export const isNlSite = () => {
  if (!isBrowser) return false;

  const { hostname, pathname } = window.location;

  // 线上环境
  if (
    hostname.endsWith('.nl') &&
    (pathname.includes('en-NL') || pathname.includes('nl-NL'))
  ) {
    return true;
  }

  // 开发/测试/预发环境 没有.nl域名
  if (
    (hostname.includes('local') ||
      hostname.includes('sbu-test-5') ||
      hostname.includes('bycloud')) &&
    (pathname.includes('en-NL') || pathname.includes('nl-NL'))
  ) {
    return true;
  }

  return false;
};

export const getLocaleByUrl = () => {
  if (!isBrowser) {
    return 'en';
  }
  const pathname = window.location.pathname;
  // if (window.$wujie) {
  //   pathname = window.$wujie.props?.initialRoute;
  // } else {
  //   pathname = window.location.pathname;
  // }

  const lang = pathname.split('/')[1] || 'en';
  const isExist = LOCALES.find((k) => k.value === lang);
  return isExist ? lang : 'en';
};

// 非测试环境跳转url返回https://testnet.bybit.com或https://www.bybit.com时做多域名适配
export const domainAbsolutePathReplace = (url: string) => {
  const origin = window.top?.location.origin || '';
  if (!origin.includes('-test-')) {
    url = url
      .replace('https://testnet.bybit.com', origin)
      .replace('https://www.bybit.com', origin);
  }
  return url;
};
